import type { ButtonHTMLAttributes } from 'react';
import { forwardRef } from 'react';
import type { ButtonSize, ButtonVariant } from './button-styles';
import { buttonClasses } from './button-styles';
import { Icon } from './Icon';
import { cx } from '@/lib/cx';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  /** Shows a spinner, disables the button and sets aria-busy. */
  loading?: boolean;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  {
    variant = 'primary',
    size = 'md',
    loading = false,
    disabled,
    className,
    children,
    type,
    ...rest
  },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type ?? 'button'}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      className={cx(buttonClasses(variant, size), className)}
      {...rest}
    >
      {loading && <Icon name="spinner" />}
      {children}
    </button>
  );
});
